<template>
    <div class="turn-prompt"
        :class="{ 'fade-out': isMyTurn && isWaitingForVote == false, 'fade-in': !isMyTurn || isWaitingForVote }">
        <div class="turn-prompt-header" v-html="roundInfo"></div>
        <!--
        <AvatarCircle class="avatar-circle" :isTurnPrompt="true" :id="id" :isTui="isWaitingForVote" :size="135"
            :sizeInner="100">
        </AvatarCircle>
    -->
        <AudioClip v-if="isMuted == false && isMyTurn" :autoplay="true" id="Game_collect" :overrideVolume="1">
        </AudioClip>

        <div v-if="isWaitingForVote" class="vote-text" v-html="T('tui_waiting_poll')"></div>
        <template v-else>
            <div class="avatar-text" v-html="promptText"></div>
            <div v-if="isMyTurn == false" class="avatar-lower-text" v-html="T('multiplayer_actions_below_disabled')">
            </div>
        </template>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
//import AvatarCircle from './AvatarCircle.vue';
import { T } from '@/App.vue';
import { users } from '../../../shared_fca/room_user';
import AudioClip from './AudioClip.vue';
import { maxRounds } from '@/configuration';

export default Vue.extend({
    name: 'TurnPrompt',
    props: {
        id: String,
        isMyTurn: Boolean,
        isWaitingForVote: Boolean,
        isMuted: Boolean,
        round: Number,
    },
    computed: {
        roundInfo: {
            cache: false,
            get(): string {

                if (!this.round) {
                    return "";
                }

                if (this.round === maxRounds) {
                    return T("roundinfo_singleplayer_finalround");
                }

                return T("roundinfo_singleplayer").replace("%", this.round.toString()).replace("$", maxRounds.toString());
            }
        },
        promptText: {
            cache: false,
            get(): string {


                if (this.isMyTurn) {
                    return T('tui_your_turn');
                }

                return T('tui_other_players_turn').replace("###", T(users[this.id].realname));

            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
    },
    components: {
        //        AvatarCircle,
        AudioClip
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.turn-prompt {
    position: absolute;
    top: 80px;
    left: 359px;
    height: 81px;
    width: 344px;
    border-radius: 8px;
    background-color: rgba(64, 70, 94, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
}

.avatar-circle {
    animation: pulse 2s infinite;
    position: absolute;
    left: -70px;
    top: -5px;
}

.avatar-text {
    position: absolute;
    font-family: Rubik;
    font-weight: 800;
    font-size: 24.5px;
    line-height: 29.03px;
    letter-spacing: 0px;
    text-align: center;
    top: 35.7px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    color: white;
}

.vote-text {
    .avatar-text;
    top: 25.7px;
}


.avatar-lower-text {
    position: absolute;
    top: 66.7px;
    font-family: Rubik;
    font-family: Rubik;
    font-weight: 400;
    font-size: 10px;
    line-height: 11.85px;
    letter-spacing: 0px;
    text-align: center;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}

.fade-out {
    animation: fadeInOut 5s;
    opacity: 0;
}

.fade-in {
    animation: fadeIn 2.5s;
    opacity: 1;
}

.turn-prompt-header {
    height: 28px;
    width: 100%;
    border-radius: 8px 8px 0 0;
    background-color: #DEDEC7;
    color: #636252;
    font-family: Rubik;
    font-weight: 800;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}



@keyframes fadeIn {

    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }

}


@keyframes fadeInOut {

    0% {
        opacity: 0;
    }

    25% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }

}

@keyframes pulse {
    0% {
        transform: scale(0.95);
    }

    50% {
        transform: scale(1);
    }

    100% {
        transform: scale(0.95);
    }
}
</style>